import { Accordion, AccordionDetails, AccordionSummary, Alert, Snackbar, SnackbarCloseReason } from "@mui/material";
import React, { useEffect } from "react";
import './ErrorSnack.css';
import { MpApiError } from "../services/common";

const ErrorSnack = () => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [errorMsg, setErrorMsg] = React.useState('');
    const [errorDetails, setErrorDetails] = React.useState('');
    const [opDetails, setOpDetails] = React.useState<string | null>(null);
    const [opResponse, setOpResponse] = React.useState<string | null>(null);
    const [autoHideDuration, setAutoHideDuration] = React.useState<number | null>(6000);

    const handleClose = (event?: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
        if (reason === 'clickaway') {
            setAutoHideDuration(6000);
            return;
        }
        setIsOpen(false);
    };

    addEventListener("error", (event) => {
        handleError(event?.message, event?.error?.stack, event?.error);
    })

    onunhandledrejection = (event) => {
        handleError(event?.reason?.message, event?.reason?.stack, event?.reason);
    }

    const loadError = async () => {
        const error = localStorage.getItem('currentError');
        const errorDetails = localStorage.getItem('currentErrorStack');
        if (error != null && errorDetails != null && error.length > 0 && errorDetails.length > 0) {
            handleError(error, errorDetails, null);
            localStorage.removeItem('currentError');
            localStorage.removeItem('currentErrorStack');
        }
    };

    const handleError = (errorMsg: string | null, errorStack: string | null, mpError: MpApiError | null) => {
        if (mpError instanceof MpApiError) {
            const apiError = mpError as MpApiError;
            if (apiError.opertationResponse === "ChatQuotaException") {
                setOpDetails(null);
                setOpResponse(null);
                setErrorMsg("Quota limit reached");
                setErrorDetails("Please contact Migration Portal Administrator in order to expand quota for you");
                setIsOpen(true);
                return;
            }
            setOpDetails("API: " + apiError.operationName + " status code returned: " + apiError.httpStatusCode);
            setOpResponse("RESPONSE: " + apiError.opertationResponse);
        }
        else {
            setOpDetails(null);
            setOpResponse(null);
        }
        setErrorMsg(errorMsg);
        setErrorDetails("STACK: " + errorStack);
        setIsOpen(true);
    };

    useEffect(() => {
        loadError();
    }, []);

    return (
        <Snackbar open={isOpen} autoHideDuration={autoHideDuration} onClose={handleClose} className="error-snack" >
            <Accordion onChange={(e, v) => v ? setAutoHideDuration(null) : setAutoHideDuration(6000) }>
                <AccordionSummary expandIcon={<div />}>
                    <Alert onClose={handleClose} severity="error" variant="filled" sx={{ width: '100%' }}>
                        {errorMsg}
                    </Alert>
                </AccordionSummary>
                <AccordionDetails>
                    {opDetails === null
                        ? ''
                        : <div>{opDetails}<br /><br /></div>
                    }
                    {opResponse === null
                        ? ''
                        : <div>{opResponse}<br /><br /></div>
                    }
                    {errorDetails}
                </AccordionDetails>
            </Accordion>
        </Snackbar>
    );
};

export default ErrorSnack;